module.exports = "/assets/images/LOGO_ATC_BLANCO.svg?56389a99f753b50032d70b3338027d23";